export default "__VITE_ASSET__DtHkF3pw__"